import Vue from 'vue';

window.axios = require('axios');

Vue.component('latest-roles', require('./LatestRoles.vue').default);

const app = new Vue({
    el: '#latest-roles'
});